var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17704",
    "data-name": "Grupo 17704",
    transform: "translate(-28 -175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15731",
    "data-name": "Grupo 15731",
    transform: "translate(0 41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_84807",
    "data-name": "Rect\\xE1ngulo 84807",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(28 134)",
    fill: "#d1f0ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ico_interfaz_doc_line",
    transform: "translate(36 181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "archivar-factura",
    d: "M16.984,4.621,14.075,1.712A5.805,5.805,0,0,0,9.943,0H6.174A4.177,4.177,0,0,0,2,4.174V15.86a4.178,4.178,0,0,0,4.174,4.174h8.347a4.178,4.178,0,0,0,4.174-4.174V8.752A5.807,5.807,0,0,0,16.984,4.62ZM15.8,5.8a4.2,4.2,0,0,1,.672.876H12.852a.836.836,0,0,1-.835-.835V2.22a4.178,4.178,0,0,1,.876.672L15.8,5.8ZM17.025,15.86a2.507,2.507,0,0,1-2.5,2.5H6.174a2.507,2.507,0,0,1-2.5-2.5V4.174a2.507,2.507,0,0,1,2.5-2.5H9.943c.136,0,.271.007.4.019V5.843a2.507,2.507,0,0,0,2.5,2.5h4.155c.013.134.019.269.019.4Zm-3.756-5.008H7.426a2.09,2.09,0,0,0-2.087,2.087v1.669a2.09,2.09,0,0,0,2.087,2.087h5.843a2.09,2.09,0,0,0,2.087-2.087V12.939A2.09,2.09,0,0,0,13.269,10.852Zm.417,3.756a.418.418,0,0,1-.417.417H7.426a.418.418,0,0,1-.417-.417V12.939a.418.418,0,0,1,.417-.417h5.843a.418.418,0,0,1,.417.417ZM5.339,8.348a.835.835,0,0,1,.835-.835H7.843a.835.835,0,1,1,0,1.669H6.174A.835.835,0,0,1,5.339,8.348Zm0-3.339a.835.835,0,0,1,.835-.835H7.843a.835.835,0,0,1,0,1.669H6.174A.835.835,0,0,1,5.339,5.009Z",
    transform: "translate(-2 -0.001)",
    fill: "#1aa8a2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.115b84989eb7b9ef7adb08c57c0b451e.svg";
export { ForwardRef as ReactComponent };